"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = require("@emotion/react");

var _util = require("../../util");

var _elements = require("../../styles/elements");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  from{\n    transform: scaleX(0);\n  }\n  to {\n    transform: scaleX(1);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var borderRadius = (0, _util.rem)(30);
var progressAnimation = (0, _react.keyframes)(_templateObject());

var container = function container(theme) {
  return /*#__PURE__*/(0, _react.css)("position:fixed;bottom:", theme.spacing[12], ";right:", theme.spacing[12], ";z-index:3000;" + (process.env.NODE_ENV === "production" ? "" : ";label:container;"));
};

var noticeWrapper = function noticeWrapper(theme) {
  return /*#__PURE__*/(0, _react.css)("box-shadow:0 2px 4px 0 rgba(", theme.color.monochrome.black_rgba, ", 0.11);color:", theme.color.monochrome.dark, ";border-radius:", borderRadius, ";position:relative;overflow:hidden;background-color:", theme.color.monochrome.white, ";min-width:", (0, _util.rem)(270), ";z-index:1;&+*{margin-top:", theme.spacing[5], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:noticeWrapper;"));
};

var closeBtn = function closeBtn(theme) {
  return /*#__PURE__*/(0, _react.css)(_elements.button.styles.preflight, ";color:", theme.color.monochrome.mediumDark, ";padding:", theme.spacing[3], ";margin-left:", theme.spacing[5], ";border-radius:4px;line-height:0;&:hover{background-color:", theme.color.monochrome.light, ";}svg{height:", theme.spacing[10], ";width:", theme.spacing[10], ";opacity:0.5;}" + (process.env.NODE_ENV === "production" ? "" : ";label:closeBtn;"));
};

var toast = function toast(theme) {
  return /*#__PURE__*/(0, _react.css)(_elements.text.styles.text2Xs(theme), ";font-weight:", theme.fontWeight.medium, ";padding:", (0, _util.rem)(7), " ", theme.spacing[7], ";min-height:", (0, _util.rem)(52), ";display:flex;align-items:center;justify-content:space-between;" + (process.env.NODE_ENV === "production" ? "" : ";label:toast;"));
};

var content = function content(_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/(0, _react.css)("display:flex;align-items:center;width:100%;&>svg{height:", theme.spacing[12], ";width:", theme.spacing[12], ";margin-right:", theme.spacing[5], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:content;"));
};

var controlBtn = function controlBtn(_ref2) {
  var theme = _ref2.theme;
  return /*#__PURE__*/(0, _react.css)(_elements.button.styles.preflight, ";font-weight:", theme.fontWeight.medium, ";margin-top:1px;" + (process.env.NODE_ENV === "production" ? "" : ";label:controlBtn;"));
};

var progress = /*#__PURE__*/(0, _react.css)("position:absolute;left:0;top:0;bottom:0;right:0;animation:", progressAnimation, " forwards;transform-origin:left center;z-index:-1;" + (process.env.NODE_ENV === "production" ? "" : ";label:progress;"));

var warning = function warning(_ref3) {
  var theme = _ref3.theme,
      ControlBtn = _ref3.ControlBtn,
      Content = _ref3.Content,
      ProgressBar = _ref3.ProgressBar;
  return /*#__PURE__*/(0, _react.css)(toast(theme), ";", ControlBtn, "{color:", theme.color.primary.warningText, ";&:hover{color:", theme.color.warning['700'], ";}}", Content, ">svg{color:", theme.color.primary.warning, ";}&+", ProgressBar, "{background-color:", theme.color.secondary.warning, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:warning;"));
};

var positive = function positive(_ref4) {
  var theme = _ref4.theme,
      ControlBtn = _ref4.ControlBtn,
      Content = _ref4.Content,
      ProgressBar = _ref4.ProgressBar;
  return /*#__PURE__*/(0, _react.css)(toast(theme), ";", ControlBtn, "{color:", theme.color.primary.positive, ";&:hover{color:", theme.color.positive['700'], ";}}", Content, ">svg{color:", theme.color.primary.positive, ";}&+", ProgressBar, "{background-color:", theme.color.secondary.positive, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:positive;"));
};

var error = function error(_ref5) {
  var theme = _ref5.theme,
      ControlBtn = _ref5.ControlBtn,
      Content = _ref5.Content,
      ProgressBar = _ref5.ProgressBar;
  return /*#__PURE__*/(0, _react.css)(toast(theme), ";", ControlBtn, "{color:", theme.color.primary.negative, ";&:hover{color:", theme.color.negative['700'], ";}}", Content, ">svg{color:", theme.color.primary.negative, ";}&+", ProgressBar, "{background-color:", theme.color.secondary.negative, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:error;"));
};

var styles = {
  noticeWrapper: noticeWrapper,
  container: container,
  toast: toast,
  controlBtn: controlBtn,
  closeBtn: closeBtn,
  progress: progress,
  content: content,
  warning: warning,
  positive: positive,
  error: error
};
exports.styles = styles;
//# sourceMappingURL=Toast.styles.js.map